import { Container } from "@/components/container";

export default function ITStrategy() {
  return (
    <div>
      <section className="bg-secondary/50 border-b">
        <Container className="py-12 md:py-16">
          <h1 className="text-3xl md:text-4xl font-semibold">IT Strategy & Roadmapping</h1>
          <p className="mt-3 text-muted-foreground max-w-2xl">
            Turn business goals into practical, budget-aware technology plans with clear milestones.
          </p>
        </Container>
      </section>
      <Container className="py-12 md:py-16 grid gap-10 md:grid-cols-3">
        <div className="md:col-span-2 space-y-6">
          <Section title="The problem">
            SMBs juggle legacy systems, tight budgets, and growing security demands. Without a plan,
            investments are reactive and costly.
          </Section>
          <Section title="Our solution">
            Collaborative workshops, current-state assessment, and a 12–24 month roadmap that aligns
            with budgets and operational capacity.
          </Section>
          <Section title="Expected outcomes">
            • Prioritized initiatives • Risk reduction • Predictable budgets • Executive and team
            alignment
          </Section>
        </div>
        <aside className="space-y-4">
          <h3 className="font-semibold">Deliverables</h3>
          <ul className="text-sm text-muted-foreground space-y-2 list-disc pl-5">
            <li>Current-state assessment</li>
            <li>12–24 month roadmap</li>
            <li>Budget and timeline estimates</li>
            <li>Security and compliance gaps</li>
            <li>Execution plan with milestones</li>
          </ul>
        </aside>
      </Container>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="space-y-2">
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="text-muted-foreground leading-relaxed">{children}</p>
    </div>
  );
}
